import { LDSingleKindContext } from 'launchdarkly-react-client-sdk';

const PRIVATE_ATTRIBUTES = Object.freeze({
	dptID: 'dptID',
	isTestOrg: 'isTestOrg',
	locID: 'locID',
	orgCreated: 'orgCreated',
	orgID: 'orgID',
	orgZip: 'orgZip'
});

const PERMITTED_CUSTOM_ATTRS = Object.freeze({
	...PRIVATE_ATTRIBUTES,
	actType: 'actType',
	created: 'created',
	isTestUser: 'isTestUser',
	roleID: 'roleID',
	state: 'state',
	zip: 'zip'
});

type CustomAttributes = Record<keyof typeof PERMITTED_CUSTOM_ATTRS, boolean | string | number>;

export const getCustomAttributes = (user: Partial<LDSingleKindContext>): CustomAttributes => {
	const custom = Object.keys(user).reduce((cust, attr) => {
		if (!PERMITTED_CUSTOM_ATTRS[attr as keyof typeof PERMITTED_CUSTOM_ATTRS]) return cust;

		return {
			...cust,
			[attr]: user[attr]
		};
	}, {} as CustomAttributes);

	return custom;
};

export const getPrivateAttributes = (user: Partial<LDSingleKindContext>): string[] => {
	const attrs = Object.keys(user).reduce((privateAttrs, attr) => {
		if (!PRIVATE_ATTRIBUTES[attr as keyof typeof PRIVATE_ATTRIBUTES]) return privateAttrs;

		return [...privateAttrs, attr];
	}, [] as string[]);
	return attrs;
};

export const getFormattedUserObject = (user: Partial<LDSingleKindContext>): LDSingleKindContext => {
	return {
		...getCustomAttributes(user),
		_meta: {
			privateAttributes: getPrivateAttributes(user)
		},
		anonymous: false,
		email: user.email,
		firstName: user.firstName,
		key: `u:${user.key}`,
		kind: user.kind ?? 'user',
		lastName: user.lastName
	};
};
